<script setup lang="ts"></script>

<template>
  <div>
    <ContentDoc
      class="prose max-w-4xl overflow-auto prose-h1:text-gray-700 prose-a:text-cyan-700 prose-a:no-underline hover:prose-a:underline prose-code:overflow-x-auto prose-pre:bg-[#24292e]"
    >
    </ContentDoc>
  </div>
</template>
